import * as React from "react"
import { IconButton } from "../buttons"
import { useBoolean } from "../../../hooks/useBoolean"
import { Container, ContainerIcons, WrapperIcons } from "./growing-menu.styled"
import { GrowingMenuProps } from "./growing-menu.interface"
import { MoreIcon } from "../icons"
import { addHitAreaStyle } from "../../../util/styleUtils"

export const GrowingMenu: React.FC<GrowingMenuProps> = ({
  numberOfVisibleElements,
  items,
  customStyles
}) => {
  const [isOpen, { toggle, off }] = useBoolean(false)

  return (
    <Container style={{ ...customStyles.container }}>
      <ContainerIcons
        isOpen={isOpen}
        numberOfVisibleElements={numberOfVisibleElements}
      >
        <WrapperIcons isOpen={isOpen} onTouchEnd={off}>
          {items.map((item, index) => (
            <React.Fragment key={`icon-${index}`}>{item}</React.Fragment>
          ))}
        </WrapperIcons>
      </ContainerIcons>
      <div style={{ position: "relative" }}>
        <IconButton
          width="1.6rem"
          height={"1.6rem"}
          onClick={() => toggle()}
          isMobile={true}
          marginRight="0.1rem"
          className="icon-ios"
          {...addHitAreaStyle({left: 5, right: 5, top: 0, bottom: 0})}
        >
          <MoreIcon />
          {/* <ToggleIcon
            onMouseDown={e => e.preventDefault()}
            style={{ ...customStyles.toggleIconStyles }}
          /> */}
        </IconButton>
      </div>
    </Container>
  )
}
